<template>
  <LcCard variant="order" with-wavy-body>
    <section class="pt-150">
      <IconList>
        <template v-if="loading">
          <LcSkeleton v-for="i in 4" :key="i" height="1rem" radius="small" />
        </template>

        <template v-else>
          <IconListItemId v-if="orderId" :id="orderId" />

          <IconListItemOrderedIn
            v-if="licensedTerritory"
            :licensed-territory="licensedTerritory as LicensedTerritory"
          />

          <IconListItemPrice v-if="price" v-bind="{ price }">
            <MyOrdersFreeTicket v-if="price.value <= 0 && gameName" :name="gameName" />
          </IconListItemPrice>

          <IconListItemScratchcardTicketsAmount
            v-if="quantity"
            v-bind="{ quantity, cancelledScratchcards }"
          />

          <MyOrdersWinnings v-if="!loading && winningsPayload" class="mt-200" variant="total">
            <div class="flex flex-wrap gap-050 items-center justify-end">
              <span v-if="winningsPayload.amount?.value">
                {{ formatMoney(winningsPayload.amount) }}
              </span>
              <span v-if="winningsPayload.freeTickets" class="free-ticket">
                <ScratchcardFreeTicketTranslation
                  :free-tickets="winningsPayload.freeTickets"
                  :type="winningsPayload.amount?.value ? 'with-prize' : 'free-ticket-only'"
                />
              </span>
            </div>
          </MyOrdersWinnings>
        </template>
      </IconList>

      <LcInfoText
        v-if="winningsPayload?.isBigWin"
        class="mt-200 text-secondary-secondary"
        icon="info"
        icon-alignment="center"
        size="small"
        :text="$t('scratchcard.order.info.bigwin')"
      />
    </section>
  </LcCard>
</template>

<script lang="ts" setup>
import type { LicensedTerritory } from '@lottocom/lottery-mapping'

import type {
  Money,
  ScratchcardDetail,
  WinningsPayload,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

import { MyOrdersWinnings } from '#components'

type ScratchcardOrderInformationCardProps = {
  gameName?: string
  licensedTerritory?: string
  loading?: boolean
  orderId?: string
  price?: Money
  quantity?: number
  scratchcards?: ScratchcardDetail[]
  winningsPayload?: Maybe<Pick<WinningsPayload, 'amount' | 'freeTickets' | 'isBigWin'>>
}

const { scratchcards = [], winningsPayload } = defineProps<ScratchcardOrderInformationCardProps>()

const cancelledScratchcards = computed(() =>
  scratchcards.filter(({ status }) => isCancelled(status)),
)
</script>

<style lang="scss" scoped>
.free-ticket {
  white-space: nowrap;
}
</style>
